import { useEffect, useState } from "react";


function useSuccessScreenHook(durationMinutes = 10) {
    const [successScreen, setSuccessScreen] = useState(false);
    const [remainingSeconds, setRemainingSeconds] = useState(0);

    useEffect(() => {
        const checkTime = () => {
            const savedTime = localStorage.getItem("lastEnquiryTime");

            if (savedTime) {
                const lastSubmitTime = new Date(savedTime);
                const now = new Date();
                const diffMs = now - lastSubmitTime;
                const diffSeconds = Math.floor(diffMs / 1000);

                const cooldownSeconds = durationMinutes * 60;
                const secondsLeft = cooldownSeconds - diffSeconds;

                if (secondsLeft > 0) {
                    setSuccessScreen(true);
                    setRemainingSeconds(secondsLeft);
                } else {
                    setSuccessScreen(false);
                    setRemainingSeconds(0);
                }
            } else {
                setSuccessScreen(false);
                setRemainingSeconds(0);
            }
        };

        checkTime();
        const interval = setInterval(checkTime, 1000); 

        return () => clearInterval(interval);
    }, [durationMinutes]);

    return successScreen;

}

export default useSuccessScreenHook;